<script lang="ts" setup>
import type { ToasterProps } from "vue-sonner"
import { CircleCheckIcon, InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon, XIcon } from "lucide-vue-next"
import { Toaster as Sonner } from "vue-sonner"
import { cn } from "@/lib/utils"

// Единственный экземпляр тостера на всё приложение (смонтирован в `app.vue`), поэтому
// позиция задаётся здесь, а не на каждом вызове `toast.*`. Всегда сверху по центру —
// и на десктопе, и на мобильных; отступ учитывает safe-area (челка/статус-бар iOS/Android),
// иначе тост уезжает под вырез. `withDefaults` нужен именно до `v-bind="props"` ниже:
// иначе в Sonner ушёл бы `undefined` и сработал бы его собственный дефолт (bottom-right).
const props = withDefaults(defineProps<ToasterProps>(), {
  position: "top-center",
  offset: () => ({
    top: "calc(env(safe-area-inset-top, 0px) + 24px)",
    right: "calc(env(safe-area-inset-right, 0px) + 24px)",
    bottom: "calc(env(safe-area-inset-bottom, 0px) + 24px)",
    left: "calc(env(safe-area-inset-left, 0px) + 24px)",
  }),
  mobileOffset: () => ({
    top: "calc(env(safe-area-inset-top, 0px) + 12px)",
    right: "calc(env(safe-area-inset-right, 0px) + 12px)",
    bottom: "calc(env(safe-area-inset-bottom, 0px) + 12px)",
    left: "calc(env(safe-area-inset-left, 0px) + 12px)",
  }),
})
</script>

<template>
  <Sonner
    :class="cn('toaster group', props.class)"
    :style="{
      '--normal-bg': 'var(--popover)',
      '--normal-text': 'var(--popover-foreground)',
      '--normal-border': 'var(--border)',
      '--border-radius': 'var(--radius)',
    }"
    v-bind="props"
  >
    <template #success-icon>
      <CircleCheckIcon class="size-4" />
    </template>
    <template #info-icon>
      <InfoIcon class="size-4" />
    </template>
    <template #warning-icon>
      <TriangleAlertIcon class="size-4" />
    </template>
    <template #error-icon>
      <OctagonXIcon class="size-4" />
    </template>
    <template #loading-icon>
      <div>
        <Loader2Icon class="size-4 animate-spin" />
      </div>
    </template>
    <template #close-icon>
      <XIcon class="size-4" />
    </template>
  </Sonner>
</template>
